export const environment = {
  production: false,
  eliquaRestURL: 'https://hollandandbarrett.uat.qivos.net/ci-hollandandbarrett-UAT/rest/v1/',
  clientName: 'hollandandbarrett',
};
